// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import htmlToPdf from '@/components/utils/htmlToPdf'
import "babel-polyfill";
import $ from 'jquery';

import less from 'less';
Vue.use(less);
Vue.prototype.$ajax = $.ajax;

Vue.use(htmlToPdf)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js